import { ReactNode } from "react";
import classNames from "classnames";

type LabelledValueProps = {
  label: string;
  children: ReactNode;
  className?: string;
  valueClassName?: string;
};

export const LabelledValue = ({
  label,
  children,
  className,
  valueClassName,
}: LabelledValueProps) => (
  <div className={classNames("t-flex t-flex-col t-gap-1 t-min-w-0", className)}>
    <span className="t-text-body-sm t-text-text-30">{label}</span>
    <div
      className={classNames(
        "t-text-subtext-sm t-text-text-100 [&>div]:!t-text-left [&_.t-justify-end]:!t-justify-start [&_.t-items-end]:!t-items-start [&_.t-justify-center]:!t-justify-start",
        valueClassName
      )}
    >
      {children}
    </div>
  </div>
);
